import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b2b7be9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bannar-box"
};
const _hoisted_2 = {
  class: "banner-box"
};
const _hoisted_3 = {
  class: "text-box"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  key: 0,
  class: "tips"
};
const _hoisted_6 = {
  class: "buttom-box"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pagination-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
})])], -1));
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.min.css';
import 'swiper/css/pagination'; // 轮播图底面的小圆点
import { Pagination, Autoplay } from 'swiper';
import ButtomCom from '@/components/buttomCom.vue';
import Banner1 from '@/assets/img/banner/index-banner1.png';
import Banner2 from '@/assets/img/banner/index-banner2.png';
export default {
  __name: 'bannarCom',
  setup(__props) {
    const bannerList = [{
      bannerImg: Banner1,
      bannerTitle: '云起无垠 — 国内首家安全智能体供应商',
      bannerTips: '打造最懂安全的AI智能体',
      bannerUrl: '',
      bannerBtn: false
    }, {
      bannerImg: Banner2,
      bannerTitle: 'SecGPT 正式发布',
      bannerTips: '全球首个网络安全开源大模型',
      bannerUrl: 'https://github.com/Clouditera/secgpt',
      bannerBtn: true
    }];
    const page_jump = url => {
      window.open(url);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Swiper), {
        modules: [_unref(Pagination), _unref(Autoplay)],
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        autoplay: {
          autoplay: false,
          delay: 3000
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(bannerList, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            class: "slide",
            style: _normalizeStyle({
              background: 'url(' + item.bannerImg + ')  center center / cover no-repeat'
            }),
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", _hoisted_4, _toDisplayString(item.bannerTitle), 1), item.bannerTips ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.bannerTips), 1)) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createVNode(ButtomCom, {
              btnName: "了解更多",
              onClick: $event => page_jump(item.bannerUrl)
            }, null, 8, ["onClick"])], 512), [[_vShow, item.bannerBtn]])])]),
            _: 2
          }, 1032, ["style"]);
        }), 64))]),
        _: 1
      }, 8, ["modules"]), _hoisted_7]);
    };
  }
};